import { useMemo } from 'react';
import { useClientGroup } from '@/common/hooks/clientGroups/hooks/useClientGroup';
import { useCore } from '$api-clients/hooks';

export function useBuyerProfileData(clientGroupId: string) {
  const {
    clientGroup,
    loading: clientGroupLoading,
    error: clientGroupError,
    mutate: mutateClientGroup,
  } = useClientGroup(clientGroupId);

  const {
    data: contacts,
    isLoading: contactsLoading,
    error: contactsError,
    mutate: mutateContacts,
  } = useCore('/interactions/{interactionId}/contacts', {
    params: {
      path: { interactionId: clientGroupId },
    },
  });

  const { clients, agents } = useMemo(() => {
    const all = contacts ?? [];
    return {
      clients: all.filter((c) => c.type === 'client'),
      agents: all.filter((c) => c.type === 'agent'),
    };
  }, [contacts]);

  const loading = clientGroupLoading || contactsLoading;
  const error = clientGroupError ?? contactsError;

  return {
    clientGroup,
    clients,
    agents,
    contacts,
    loading,
    error,
    mutateContacts,
    mutateClientGroup,
  };
}
